export default __webpack_public_path__ + "static/media/underconstruction.b62307ac.png";